/**
 * Extracts the trailing identifier (UUID) from a base64-encoded GraphQL
 * relay ID such as `iri://ghostwriter/GhostwriterFormField/<uuid>`.
 *
 * Different schema types may encode the same entity with different type
 * prefixes (e.g. `GhostwriterFormField` vs `FormField`), so comparing
 * the suffix is more reliable than comparing the full relay ID.
 */
export function relayIdSuffix(relayId: string): string {
  try {
    const decoded = atob(relayId);
    const lastSlash = decoded.lastIndexOf("/");
    return lastSlash >= 0 ? decoded.slice(lastSlash + 1) : decoded;
  } catch {
    return relayId;
  }
}
